import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "pages", "value", "className", "color"];
import React, { forwardRef, useCallback } from 'react';
import { cnBem } from '@carnica/utils';
import { useMutableRef } from '@carnica/utils/hooks';
import { withRenderFlag } from '@beef/react';
import styles from "./styles.pcss";
import { usePages } from "./hooks/usePages/usePages";
import { PagePaginationItem } from "./PagePaginationItem";
import { PagePaginationNavigateButton } from "./PagePaginationNavigateButton";
var cnPagePagination = cnBem('page-pagination', styles);
var PagePaginationRender = /*#__PURE__*/forwardRef(function (props, ref) {
  var onChange = props.onChange,
    _props$pages = props.pages,
    pages = _props$pages === void 0 ? 0 : _props$pages,
    _props$value = props.value,
    value = _props$value === void 0 ? 1 : _props$value,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var currentPage = Math.max(Math.min(value, pages || 0), 0);
  var _usePages = usePages(currentPage, pages),
    list = _usePages.list,
    showNextButton = _usePages.showNextButton,
    showPrevButton = _usePages.showPrevButton;
  var onChangeRef = useMutableRef(onChange);
  var handleChange = useCallback(function (page) {
    return function (e) {
      var _onChangeRef$current;
      return (_onChangeRef$current = onChangeRef.current) === null || _onChangeRef$current === void 0 ? void 0 : _onChangeRef$current.call(onChangeRef, page, e);
    };
  }, []);
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: cnPagePagination(null, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "components-PagePagination"
  }), showPrevButton && /*#__PURE__*/React.createElement("li", {
    className: cnPagePagination('item')
  }, /*#__PURE__*/React.createElement(PagePaginationNavigateButton, {
    color: color,
    direction: "prev",
    disabled: currentPage < 2,
    onClick: handleChange(currentPage - 1)
  })), list.map(function (el, i) {
    return /*#__PURE__*/React.createElement("li", {
      className: cnPagePagination('item'),
      key: "".concat(el.page, "-").concat(i)
    }, /*#__PURE__*/React.createElement(PagePaginationItem, _extends({}, el, {
      active: el.page === currentPage,
      color: color,
      "data-item-type": el.type,
      "data-page": el.page,
      onChangePage: onChange
    })));
  }), showNextButton && /*#__PURE__*/React.createElement("li", {
    className: cnPagePagination('item')
  }, /*#__PURE__*/React.createElement(PagePaginationNavigateButton, {
    color: color,
    direction: "next",
    disabled: currentPage >= pages,
    onClick: handleChange(currentPage + 1)
  })));
});
export var PagePagination = withRenderFlag({
  shouldRenderFn: function shouldRenderFn(_ref) {
    var _ref$pages = _ref.pages,
      pages = _ref$pages === void 0 ? 0 : _ref$pages;
    return pages > 1;
  }
})(PagePaginationRender);